export default __webpack_public_path__ + "resources/icons/d412-d0d7.webp";